import type { UseQueryResult } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { apiClient } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import type { ResponseError } from "app/services/fetchService";

import type { IBrandVisibilityGraphResponse } from "../brands-visibility/types";

const UNAUTHORIZED_ERROR = 401;

export const useBrandVisibilityGraphData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<IBrandVisibilityGraphResponse> =>
    useLLMReportQuery<IBrandVisibilityGraphResponse, ILLMWidgetRequestParams>(
        "brandVisibilityGraphData",
        apiClient.AiTracker.aiTrackerReportsBrandVisibilityReportGraphList,
        params,
        {
            ...options,
            throwOnError: (error: ResponseError) => {
                if (error?.status !== UNAUTHORIZED_ERROR) {
                    Sentry.errorTracker({
                        e: error,
                        message: "Error fetching Brand Visibility Graph data",
                        level: "error",
                        params: { extra: { ...params } },
                    });
                }

                return false;
            },
        },
    );
